var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "#FB3256"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.88 42.83H179.58V45.77H170.88V42.83ZM171.39 49.97H180.93V53H167.61V35.84H180.6V38.9H171.39V49.97ZM184.837 53V35.84H192.607C194.567 35.84 196.257 36.19 197.677 36.89C199.117 37.59 200.227 38.59 201.007 39.89C201.807 41.17 202.207 42.68 202.207 44.42C202.207 46.18 201.807 47.7 201.007 48.98C200.227 50.26 199.117 51.25 197.677 51.95C196.257 52.65 194.567 53 192.607 53H184.837ZM188.617 49.94H192.487C193.707 49.94 194.757 49.72 195.637 49.28C196.517 48.84 197.197 48.21 197.677 47.39C198.157 46.57 198.397 45.58 198.397 44.42C198.397 43.26 198.157 42.27 197.677 41.45C197.197 40.63 196.517 40.01 195.637 39.59C194.757 39.15 193.707 38.93 192.487 38.93H188.617V49.94ZM213.668 53.3C212.028 53.3 210.618 53 209.438 52.4C208.278 51.78 207.388 50.9 206.768 49.76C206.148 48.6 205.838 47.23 205.838 45.65V35.84H209.618V45.53C209.618 47.01 209.968 48.14 210.668 48.92C211.368 49.7 212.378 50.09 213.698 50.09C214.998 50.09 215.988 49.71 216.668 48.95C217.368 48.17 217.718 47.03 217.718 45.53V35.84H221.438V45.65C221.438 47.23 221.128 48.6 220.508 49.76C219.908 50.9 219.028 51.78 217.868 52.4C216.708 53 215.308 53.3 213.668 53.3ZM234.507 53.3C232.707 53.3 231.097 52.92 229.677 52.16C228.257 51.38 227.137 50.32 226.317 48.98C225.497 47.64 225.087 46.12 225.087 44.42C225.087 42.72 225.497 41.21 226.317 39.89C227.137 38.55 228.257 37.5 229.677 36.74C231.097 35.96 232.707 35.57 234.507 35.57C236.067 35.57 237.427 35.81 238.587 36.29C239.767 36.75 240.767 37.48 241.587 38.48L239.127 40.82C238.527 40.12 237.847 39.61 237.087 39.29C236.327 38.95 235.507 38.78 234.627 38.78C233.527 38.78 232.537 39.02 231.657 39.5C230.797 39.98 230.117 40.65 229.617 41.51C229.137 42.35 228.897 43.32 228.897 44.42C228.897 45.52 229.137 46.5 229.617 47.36C230.117 48.22 230.797 48.89 231.657 49.37C232.537 49.85 233.527 50.09 234.627 50.09C235.507 50.09 236.327 49.92 237.087 49.58C237.847 49.24 238.527 48.72 239.127 48.02L241.587 50.39C240.767 51.37 239.767 52.1 238.587 52.58C237.407 53.06 236.047 53.3 234.507 53.3ZM241.813 53L249.613 35.84H253.363L261.133 53H257.383L250.843 37.76H252.103L245.503 53H241.813ZM245.683 49.28L246.703 46.4H255.643L256.663 49.28H245.683ZM265.682 53V38.93H260.042V35.84H275.102V38.93H269.462V53H265.682ZM277.825 53V35.84H281.605V53H277.825ZM294.889 53.3C293.069 53.3 291.439 52.92 289.999 52.16C288.579 51.38 287.459 50.32 286.639 48.98C285.819 47.64 285.409 46.12 285.409 44.42C285.409 42.72 285.819 41.21 286.639 39.89C287.459 38.55 288.579 37.5 289.999 36.74C291.439 35.96 293.059 35.57 294.859 35.57C296.679 35.57 298.299 35.96 299.719 36.74C301.159 37.5 302.289 38.55 303.109 39.89C303.929 41.21 304.339 42.72 304.339 44.42C304.339 46.12 303.929 47.64 303.109 48.98C302.289 50.32 301.159 51.38 299.719 52.16C298.299 52.92 296.689 53.3 294.889 53.3ZM294.859 50.09C295.959 50.09 296.929 49.85 297.769 49.37C298.629 48.87 299.299 48.19 299.779 47.33C300.259 46.47 300.499 45.5 300.499 44.42C300.499 43.32 300.249 42.35 299.749 41.51C299.269 40.65 298.609 39.98 297.769 39.5C296.929 39.02 295.969 38.78 294.889 38.78C293.809 38.78 292.839 39.02 291.979 39.5C291.119 39.98 290.439 40.65 289.939 41.51C289.459 42.35 289.219 43.32 289.219 44.42C289.219 45.5 289.459 46.47 289.939 47.33C290.439 48.19 291.119 48.87 291.979 49.37C292.839 49.85 293.799 50.09 294.859 50.09ZM308.118 53V35.84H311.238L321.588 48.38H320.178V35.84H323.928V53H320.808L310.458 40.46H311.898V53H308.118ZM334.684 53L342.484 35.84H346.234L354.004 53H350.254L343.714 37.76H344.974L338.374 53H334.684ZM338.554 49.28L339.574 46.4H348.514L349.534 49.28H338.554ZM356.458 53V35.84H359.578L369.928 48.38H368.518V35.84H372.268V53H369.148L358.798 40.46H360.238V53H356.458ZM377.493 53V35.84H385.263C387.223 35.84 388.913 36.19 390.333 36.89C391.773 37.59 392.883 38.59 393.663 39.89C394.463 41.17 394.863 42.68 394.863 44.42C394.863 46.18 394.463 47.7 393.663 48.98C392.883 50.26 391.773 51.25 390.333 51.95C388.913 52.65 387.223 53 385.263 53H377.493ZM381.273 49.94H385.143C386.363 49.94 387.413 49.72 388.293 49.28C389.173 48.84 389.853 48.21 390.333 47.39C390.813 46.57 391.053 45.58 391.053 44.42C391.053 43.26 390.813 42.27 390.333 41.45C389.853 40.63 389.173 40.01 388.293 39.59C387.413 39.15 386.363 38.93 385.143 38.93H381.273V49.94ZM414.975 53.3C413.175 53.3 411.565 52.92 410.145 52.16C408.725 51.38 407.605 50.32 406.785 48.98C405.965 47.64 405.555 46.12 405.555 44.42C405.555 42.72 405.965 41.21 406.785 39.89C407.605 38.55 408.725 37.5 410.145 36.74C411.565 35.96 413.175 35.57 414.975 35.57C416.535 35.57 417.895 35.81 419.055 36.29C420.235 36.75 421.235 37.48 422.055 38.48L419.595 40.82C418.995 40.12 418.315 39.61 417.555 39.29C416.795 38.95 415.975 38.78 415.095 38.78C413.995 38.78 413.005 39.02 412.125 39.5C411.265 39.98 410.585 40.65 410.085 41.51C409.605 42.35 409.365 43.32 409.365 44.42C409.365 45.52 409.605 46.5 410.085 47.36C410.585 48.22 411.265 48.89 412.125 49.37C413.005 49.85 413.995 50.09 415.095 50.09C415.975 50.09 416.795 49.92 417.555 49.58C418.315 49.24 418.995 48.72 419.595 48.02L422.055 50.39C421.235 51.37 420.235 52.1 419.055 52.58C417.875 53.06 416.515 53.3 414.975 53.3ZM433.131 53.3C431.491 53.3 430.081 53 428.901 52.4C427.741 51.78 426.851 50.9 426.231 49.76C425.611 48.6 425.301 47.23 425.301 45.65V35.84H429.081V45.53C429.081 47.01 429.431 48.14 430.131 48.92C430.831 49.7 431.841 50.09 433.161 50.09C434.461 50.09 435.451 49.71 436.131 48.95C436.831 48.17 437.181 47.03 437.181 45.53V35.84H440.901V45.65C440.901 47.23 440.591 48.6 439.971 49.76C439.371 50.9 438.491 51.78 437.331 52.4C436.171 53 434.771 53.3 433.131 53.3ZM445.96 53V35.84H449.74V49.94H458.56V53H445.96ZM462.586 53V38.93H456.946V35.84H472.006V38.93H466.366V53H462.586ZM482.379 53.3C480.739 53.3 479.329 53 478.149 52.4C476.989 51.78 476.099 50.9 475.479 49.76C474.859 48.6 474.549 47.23 474.549 45.65V35.84H478.329V45.53C478.329 47.01 478.679 48.14 479.379 48.92C480.079 49.7 481.089 50.09 482.409 50.09C483.709 50.09 484.699 49.71 485.379 48.95C486.079 48.17 486.429 47.03 486.429 45.53V35.84H490.149V45.65C490.149 47.23 489.839 48.6 489.219 49.76C488.619 50.9 487.739 51.78 486.579 52.4C485.419 53 484.019 53.3 482.379 53.3ZM495.208 53V35.84H502.618C504.158 35.84 505.488 36.09 506.608 36.59C507.728 37.07 508.588 37.77 509.188 38.69C509.808 39.61 510.118 40.72 510.118 42.02C510.118 43.3 509.808 44.4 509.188 45.32C508.588 46.24 507.728 46.94 506.608 47.42C505.488 47.9 504.158 48.14 502.618 48.14H497.308L498.988 46.49V53H495.208ZM506.368 53L501.958 46.76H506.038L510.448 53H506.368ZM498.988 46.94L497.608 45.17H502.348C503.668 45.17 504.658 44.9 505.318 44.36C505.978 43.8 506.308 43.02 506.308 42.02C506.308 41.02 505.978 40.25 505.318 39.71C504.658 39.17 503.668 38.9 502.348 38.9H497.608L498.988 37.16V46.94ZM517.579 42.83H526.279V45.77H517.579V42.83ZM518.089 49.97H527.629V53H514.309V35.84H527.299V38.9H518.089V49.97Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.4b96c588c4596bd83bdea3f879e1dbcc.svg";
export { ForwardRef as ReactComponent };